/**
 * The six team colors as a radio group, shared by both dialogs that ask for
 * one. Plain radios inside labels: the browser supplies arrow-key movement,
 * and the dialogs' stylesheet reads the checked state through :has().
 */

import type { TeamColor } from "../../server/protocol.js";
import { h } from "../dom.js";
import { TEAM_COLOR_LABELS, TEAM_COLOR_ORDER } from "../palette.js";

export interface ColorSwatches {
    readonly element: HTMLDivElement;
    /** The color currently checked. */
    readonly read: () => TeamColor;
    readonly check: (color: TeamColor) => void;
}

export function createColorSwatches(groupName: string): ColorSwatches {
    const inputs = TEAM_COLOR_ORDER.map((color) => ({
        color,
        input: h("input", { type: "radio", name: groupName, value: color })
    }));

    const element = h("div", { class: "swatches" }, ...inputs.map(({ color, input }) => {
        const label = h(
            "label",
            { class: "swatch" },
            input,
            h("span", { "class": "chip", "aria-hidden": "true" }),
            h("span", {}, TEAM_COLOR_LABELS[color])
        );

        label.style.setProperty("--team", `var(--team-${color})`);

        return label;
    }));

    return {
        element,
        read: () => inputs.find(({ input }) => input.checked)?.color ?? "purple",
        check: (color) => {
            for (const entry of inputs) {
                entry.input.checked = entry.color === color;
            }
        }
    };
}
